import MuiButton from '@mui/material/Button';
import { clsx } from 'clsx';
import { FC } from 'react';
import { Link } from 'atoms/Link/Link';
import { IButton } from './types';
import styles from './styles.module.css';

export const Button: FC<IButton> = ({ style, className, ...props }) => {
  return (
    <MuiButton
      component={props.href ? Link : 'button'}
      classes={{ root: clsx(styles.root, className) }}
      variant="contained"
      color="default"
      style={style}
      {...props}
    />
  );
};
